export default __webpack_public_path__ + "images/49b4d4c159f0e959f9a7722521c1f6db.png";